import { AxiosRequestConfig } from 'axios'

const getArticle = (url: string, id: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: `${url}/${id}`
  }
}

export default getArticle
